import PropertyStickyContainer from "../../../../components/property/detail/PropertySticky";

const PropertySticky = () => {
  return <PropertyStickyContainer />;
};

export default PropertySticky;
